import { render, staticRenderFns } from "./JobDescriptionFileTypeIcon.vue?vue&type=template&id=7d44ba7b&scoped=true"
import script from "./JobDescriptionFileTypeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDescriptionFileTypeIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobDescriptionFileTypeIcon.vue?vue&type=style&index=0&id=7d44ba7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d44ba7b",
  null
  
)

export default component.exports